(function () {
  function getProductData(section) {
    const jsonEl = section.querySelector('.product-json');
    if (!jsonEl) return null;
    try {
      return JSON.parse(jsonEl.textContent);
    } catch (error) {
      return null;
    }
  }

  function formatMoney(cents, format) {
    if (typeof theme !== 'undefined' && theme.Helpers && theme.Helpers.formatMoney) {
      return theme.Helpers.formatMoney(cents, format);
    }
    return (cents / 100).toFixed(2);
  }

  function bindGallery(section) {
    const gallery = section.querySelector('[data-mt-product-gallery]');
    if (!gallery) return;

    const mainImage = gallery.querySelector('[data-mt-main-image]');
    const thumbs = Array.from(gallery.querySelectorAll('[data-mt-thumb]'));
    const track = gallery.querySelector('[data-mt-thumbs-track]');
    const viewport = gallery.querySelector('[data-mt-thumbs-viewport]');
    const prevBtn = gallery.querySelector('[data-mt-thumb-prev]');
    const nextBtn = gallery.querySelector('[data-mt-thumb-next]');

    const mobileThumbMq = window.matchMedia('(max-width: 749px)');

    function clamp(value, min, max) {
      return Math.max(min, Math.min(max, value));
    }

    function isHorizontalThumbs() {
      return mobileThumbMq.matches && !!viewport;
    }

    function getMaxOffset() {
      if (!track || !viewport) return 0;
      if (isHorizontalThumbs()) {
        return Math.max(0, track.scrollWidth - viewport.clientWidth);
      }
      return Math.max(0, track.scrollHeight - viewport.clientHeight);
    }

    function getScrollOffset() {
      if (!viewport) return 0;
      return isHorizontalThumbs() ? viewport.scrollLeft : viewport.scrollTop;
    }

    function getThumbStep() {
      const thumb = thumbs[0];
      if (!thumb) return 87;
      const gap = 5;
      return (isHorizontalThumbs() ? thumb.offsetWidth : thumb.offsetHeight) + gap;
    }

    function updateArrowState(maxOffset) {
      // Track can be looped, so arrows should never be disabled.
      if (prevBtn) prevBtn.disabled = false;
      if (nextBtn) nextBtn.disabled = false;
    }

    function ensureThumbVisible(thumb) {
      if (!thumb || !track || !viewport) return;

      const maxOffset = getMaxOffset();

      if (isHorizontalThumbs()) {
        const left = thumb.offsetLeft;
        const right = left + thumb.offsetWidth;
        const viewLeft = viewport.scrollLeft;
        const viewRight = viewLeft + viewport.clientWidth;

        if (left < viewLeft) {
          viewport.scrollLeft = clamp(left, 0, maxOffset);
        } else if (right > viewRight) {
          viewport.scrollLeft = clamp(right - viewport.clientWidth, 0, maxOffset);
        }
      } else {
        const top = thumb.offsetTop;
        const bottom = top + thumb.offsetHeight;
        const viewTop = viewport.scrollTop;
        const viewBottom = viewTop + viewport.clientHeight;

        if (top < viewTop) {
          viewport.scrollTop = clamp(top, 0, maxOffset);
        } else if (bottom > viewBottom) {
          viewport.scrollTop = clamp(bottom - viewport.clientHeight, 0, maxOffset);
        }
      }

      updateArrowState(maxOffset);
    }

    function ensureThumbAtStart(thumb) {
      if (!thumb || !track || !viewport) return;

      const maxOffset = getMaxOffset();
      if (isHorizontalThumbs()) {
        viewport.scrollLeft = clamp(thumb.offsetLeft, 0, maxOffset);
      } else {
        // Keep the active thumb fully visible below the "up" arrow button,
        // even if that arrow is visually overlaying the viewport.
        const obstruction = prevBtn ? prevBtn.offsetHeight + 5 : 0;
        viewport.scrollTop = clamp(thumb.offsetTop - obstruction, 0, maxOffset);
      }
      updateArrowState(maxOffset);
    }

    function setActiveThumb(thumb, options) {
      const alignToStart = !!(options && options.alignToStart);
      thumbs.forEach(function (btn) {
        const active = btn === thumb;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (alignToStart) {
        ensureThumbAtStart(thumb);
      } else {
        ensureThumbVisible(thumb);
      }
    }

    function setMainImageFromThumb(thumb, options) {
      if (!mainImage || !thumb) return;
      const img = thumb.querySelector('img');
      if (!img) return;
      mainImage.src = thumb.dataset.fullSrc || img.currentSrc || img.src;
      mainImage.removeAttribute('srcset');
      mainImage.setAttribute('data-media-id', thumb.dataset.mediaId || '');
      mainImage.alt = img.alt || '';
      setActiveThumb(thumb, options);
    }

    function updateThumbNav() {
      if (!track || !viewport) return;
      const maxOffset = getMaxOffset();
      const scrollOffset = getScrollOffset();

      if (scrollOffset > maxOffset) {
        if (isHorizontalThumbs()) {
          viewport.scrollLeft = maxOffset;
        } else {
          viewport.scrollTop = maxOffset;
        }
      }

      updateArrowState(maxOffset);
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        setMainImageFromThumb(thumb);
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (!viewport) return;
        const maxOffset = getMaxOffset();
        const scrollOffset = getScrollOffset();
        const delta = getThumbStep();
        if (isHorizontalThumbs()) {
          if (maxOffset > 1 && scrollOffset <= 1) {
            viewport.scrollLeft = maxOffset;
            return;
          }
          viewport.scrollBy({ left: -delta, behavior: 'smooth' });
        } else {
          if (maxOffset > 1 && scrollOffset <= 1) {
            viewport.scrollTop = maxOffset;
            return;
          }
          viewport.scrollBy({ top: -delta, behavior: 'smooth' });
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (!viewport) return;
        const maxOffset = getMaxOffset();
        const scrollOffset = getScrollOffset();
        const delta = getThumbStep();
        if (isHorizontalThumbs()) {
          if (maxOffset > 1 && scrollOffset >= maxOffset - 1) {
            viewport.scrollLeft = 0;
            return;
          }
          viewport.scrollBy({ left: delta, behavior: 'smooth' });
        } else {
          if (maxOffset > 1 && scrollOffset >= maxOffset - 1) {
            viewport.scrollTop = 0;
            return;
          }
          viewport.scrollBy({ top: delta, behavior: 'smooth' });
        }
      });
    }

    if (viewport) {
      viewport.addEventListener('scroll', updateThumbNav, { passive: true });
    }

    function onThumbLayoutChange() {
      if (viewport) {
        viewport.scrollLeft = 0;
        viewport.scrollTop = 0;
      }
      updateThumbNav();
    }

    if (mobileThumbMq.addEventListener) {
      mobileThumbMq.addEventListener('change', onThumbLayoutChange);
    } else if (mobileThumbMq.addListener) {
      mobileThumbMq.addListener(onThumbLayoutChange);
    }

    window.addEventListener('resize', onThumbLayoutChange);

    updateThumbNav();

    section.mtSetMainImageByMediaId = function (mediaId) {
      if (!mediaId) return;
      const thumb = thumbs.find(function (btn) {
        return String(btn.dataset.mediaId) === String(mediaId);
      });
      // When the variant changes, keep the active thumbnail pinned to the top/left
      // of the viewport so it's immediately visible.
      if (thumb) setMainImageFromThumb(thumb, { alignToStart: true });
    };

    section.mtSetMainImageByImageSrc = function (src) {
      if (!src) return;
      const normalized = String(src).split('?')[0];
      const thumb = thumbs.find(function (btn) {
        const mediaSrc = (btn.dataset.mediaSrc || '').split('?')[0];
        return mediaSrc && (mediaSrc === normalized || normalized.endsWith(mediaSrc) || mediaSrc.endsWith(normalized));
      });
      if (thumb) setMainImageFromThumb(thumb, { alignToStart: true });
    };
  }

  function bindDiscountCopy(section) {
    section.querySelectorAll('[data-mt-copy-code]').forEach(function (button) {
      button.addEventListener('click', function () {
        const code = button.dataset.mtCopyCode;
        if (!code) return;

        const copy = function () {
          button.classList.add('is-copied');
          window.setTimeout(function () {
            button.classList.remove('is-copied');
          }, 1500);
        };

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(copy).catch(function () {
            window.prompt('Copy discount code:', code);
          });
        } else {
          window.prompt('Copy discount code:', code);
          copy();
        }
      });
    });
  }

  function bindQuantityControls(section) {
    const qtyWrap = section.querySelector('[data-mt-product-qty]');
    if (!qtyWrap || qtyWrap.dataset.mtQtyBound === 'true') return;

    qtyWrap.dataset.mtQtyBound = 'true';

    const input = qtyWrap.querySelector('.formQty');
    const downBtn = qtyWrap.querySelector('.quantity-control-down');
    const upBtn = qtyWrap.querySelector('.quantity-control-up');

    if (!input) return;

    function adjustQuantity(delta) {
      const current = parseInt(input.value, 10) || 1;
      const next = Math.max(1, current + delta);
      input.value = String(next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (downBtn) {
      downBtn.addEventListener('click', function (event) {
        event.preventDefault();
        adjustQuantity(-1);
      });
    }

    if (upBtn) {
      upBtn.addEventListener('click', function (event) {
        event.preventDefault();
        adjustQuantity(1);
      });
    }
  }

  function getFormConfig(section) {
    const form = section.querySelector('[data-product-form]');
    if (!form || !form.dataset.productForm) return {};
    try {
      return JSON.parse(form.dataset.productForm);
    } catch (error) {
      return {};
    }
  }

  function getSelectedVariant(section) {
    const product = getProductData(section);
    if (!product) return null;

    const variant = syncVariantIdFromSelection(section);
    if (variant) return variant;

    const form = section.querySelector('.js-prod-form-submit');
    if (!form) return null;

    const variantId = parseInt(form.querySelector('input[name="id"]')?.value, 10);
    if (!variantId) return null;

    return product.variants.find(function (v) {
      return v.id === variantId;
    }) || null;
  }

  function syncVariantIdFromSelection(section) {
    const product = getProductData(section);
    const form = section.querySelector('.js-prod-form-submit');
    if (!product || !form) return null;

    const optionsWrap = section.querySelector('.mt-product-information__options');
    let variant = null;

    if (optionsWrap && product.variants.length > 1) {
      const groups = optionsWrap.querySelectorAll('.js-variant-selector');
      const options = Array.from(groups).map(function (group) {
        const checked = group.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });

      if (!options.some(function (option) { return option == null; })) {
        variant = product.variants.find(function (v) {
          return v.options.every(function (option, index) {
            return options[index] === option;
          });
        }) || null;
      }
    } else if (product.variants.length === 1) {
      variant = product.variants[0];
    }

    if (!variant) {
      const variantId = parseInt(form.querySelector('input[name="id"]')?.value, 10);
      if (variantId) {
        variant = product.variants.find(function (v) { return v.id === variantId; }) || null;
      }
    }

    if (!variant) return null;

    form.querySelectorAll('input[name="id"]').forEach(function (input) {
      input.value = String(variant.id);
    });

    const sectionId = section.dataset.sectionId;
    const installmentForm = section.querySelector(
      '#product-form-installment-' + sectionId + ', #product-form-installment'
    );
    if (installmentForm) {
      installmentForm.querySelectorAll('input[name="id"], select[name="id"]').forEach(function (input) {
        input.value = String(variant.id);
      });
    }

    return variant;
  }

  function updateAddToCartState(section, variant) {
    const atcBtn = section.querySelector('.mt-product-information__atc.js-ajax-submit');
    if (!atcBtn) return;

    const buttons = section.querySelector('.mt-product-information__buttons');

    const config = getFormConfig(section);
    const addLabel = section.dataset.atcLabel || config.button || 'Add to cart';
    const soldOutLabel = section.dataset.soldOutLabel || config.sold_out || 'Sold out';
    const unavailableLabel = section.dataset.unavailableLabel || config.unavailable || 'Unavailable';

    if (!variant) {
      atcBtn.value = unavailableLabel;
      atcBtn.disabled = true;
      atcBtn.classList.add('disabled');
      atcBtn.classList.remove('is-sold-out');
      atcBtn.setAttribute('aria-disabled', 'true');
    } else if (!variant.available) {
      atcBtn.value = soldOutLabel;
      atcBtn.disabled = true;
      atcBtn.classList.add('disabled', 'is-sold-out');
      atcBtn.setAttribute('aria-disabled', 'true');
    } else {
      atcBtn.value = addLabel;
      atcBtn.disabled = false;
      atcBtn.classList.remove('disabled', 'is-sold-out');
      atcBtn.removeAttribute('aria-disabled');
    }

    if (buttons) {
      buttons.classList.toggle('is-sold-out', !!variant && !variant.available);
      buttons.classList.toggle('is-unavailable', !variant);
    }

    const dynamicCheckout = section.querySelector('.mt-product-information__dynamic-checkout');
    if (dynamicCheckout) {
      dynamicCheckout.hidden = !variant || !variant.available;
    }
  }

  function showInlineCartError(section, message) {
    const errorMsg = section.querySelector('.js-error-msg');
    if (!errorMsg) return;

    const bold = errorMsg.querySelector('b');
    if (bold) {
      bold.textContent = message;
    } else {
      errorMsg.textContent = message;
    }

    if (typeof theme !== 'undefined' && theme.Helpers && theme.Helpers.fadeIn) {
      theme.Helpers.fadeIn(errorMsg);
    } else {
      errorMsg.style.display = '';
    }

    window.setTimeout(function () {
      if (typeof theme !== 'undefined' && theme.Helpers && theme.Helpers.fadeOut) {
        theme.Helpers.fadeOut(errorMsg);
      }
    }, 4000);
  }

  function initAddToCartAvailability(section) {
    updateAddToCartState(section, getSelectedVariant(section));
  }

  function prepareMainAddToCartForm(section) {
    syncVariantIdFromSelection(section);

    const form = section.querySelector('.js-prod-form-submit');
    if (!form) return null;

    const qtyInput = form.querySelector('[name="quantity"]');
    if (qtyInput && qtyInput.type !== 'hidden') {
      const parsed = parseInt(qtyInput.value, 10);
      qtyInput.value = String(!parsed || parsed < 1 ? 1 : parsed);
    }

    return form;
  }

  function bindMainAddToCart(section) {
    if (section.dataset.mtDelegatesBound === 'true') return;

    section.dataset.mtDelegatesBound = 'true';

    section.addEventListener('change', function (event) {
      if (!event.target.matches('.mt-product-information__options input[type="radio"]')) return;

      const variant = syncVariantIdFromSelection(section);
      updateAddToCartState(section, variant);
    });

    section.addEventListener('click', function (event) {
      const btn = event.target.closest('.mt-product-information__atc.js-ajax-submit');
      if (!btn || btn.disabled) return;

      const form = section.querySelector('.js-prod-form-submit');
      if (!form || !form.contains(btn)) return;

      event.preventDefault();
      event.stopPropagation();

      if (form.dataset.ajaxCartSubmitting === 'true') return;

      prepareMainAddToCartForm(section);

      const config = getCartConfig();
      if (!config || typeof Shopify === 'undefined' || !Shopify.theme || !Shopify.theme.ajaxCart) return;

      const variantId = form.querySelector('[name="id"]')?.value || '';
      const lockKey = (form.id || 'cart-form') + ':' + variantId;
      const now = Date.now();
      const lastAttempt = Shopify.theme.ajaxCart._lastAddAttempt;

      if (lastAttempt && lastAttempt.key === lockKey && now - lastAttempt.time < 800) {
        return;
      }

      Shopify.theme.ajaxCart._lastAddAttempt = { key: lockKey, time: now };

      const context = btn.closest('.mt-product-information__buttons') || btn.parentNode;
      Shopify.theme.ajaxCart.addToCart(form, context, config, false);
    });
  }

  function stripPriceFromPrefix(section) {
    const priceWrap = section.querySelector('.mt-product-information__price-wrap');
    if (!priceWrap) return;

    priceWrap.querySelectorAll('.price-item--regular, .price-item--sale').forEach(function (el) {
      const text = (el.textContent || '').trim();
      if (/^from\s+/i.test(text)) {
        el.textContent = text.replace(/^from\s+/i, '');
      }
    });
  }

  function bindPriceFromCleanup(section) {
    if (section.dataset.mtPriceFromBound === 'true') return;
    section.dataset.mtPriceFromBound = 'true';

    stripPriceFromPrefix(section);

    const priceWrap = section.querySelector('.mt-product-information__price-wrap');
    if (!priceWrap) return;

    const variantForm = section.querySelector('[data-product-form]');
    if (variantForm) {
      variantForm.addEventListener('change', function () {
        window.setTimeout(function () {
          stripPriceFromPrefix(section);
        }, 0);
      });
    }

    if (typeof MutationObserver !== 'undefined') {
      const observer = new MutationObserver(function () {
        stripPriceFromPrefix(section);
      });
      observer.observe(priceWrap, { childList: true, subtree: true, characterData: true });
    }
  }

  function bindVariantExtras(section) {
    if (section.dataset.mtVariantPickerBound === 'true') return;
    section.dataset.mtVariantPickerBound = 'true';

    const product = getProductData(section);
    const optionsWrap = section.querySelector('.mt-product-information__options');
    if (!product || !optionsWrap || product.variants.length <= 1) return;

    const moneyFormat = product.money_format || (typeof theme !== 'undefined' && theme.moneyFormat);

    function getGroups() {
      return Array.from(optionsWrap.querySelectorAll('.js-variant-selector'));
    }

    function getCheckedOptions() {
      return getGroups().map(function (group) {
        const checked = group.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });
    }

    function matchVariant(options) {
      if (options.some(function (option) { return option == null; })) return null;
      return product.variants.find(function (variant) {
        return variant.options.every(function (option, index) {
          return options[index] === option;
        });
      }) || null;
    }

    function applyVariantToUi(variant) {
      if (!variant) return;
      variant.options.forEach(function (value, index) {
        const group = getGroups()[index];
        if (!group) return;
        group.querySelectorAll('input[type="radio"]').forEach(function (radio) {
          if (radio.value === value) {
            radio.disabled = false;
            radio.checked = true;
          } else {
            radio.checked = false;
          }
        });
      });
    }

    function updateOptionLabels() {
      optionsWrap.querySelectorAll('input[type="radio"]:checked').forEach(function (input) {
        const label = optionsWrap.querySelector('#selected-option-' + input.dataset.position);
        if (label) label.textContent = input.value;
      });
    }

    function updateSoldOutStates() {
      const selected = {};
      optionsWrap.querySelectorAll('input[type="radio"]:checked').forEach(function (input) {
        selected['option' + input.dataset.position] = input.value;
      });

      optionsWrap.querySelectorAll('input[type="radio"]').forEach(function (input) {
        const optKey = 'option' + input.dataset.position;
        const val = input.value;
        let availableWithSelection = false;
        let availableAnywhere = false;

        product.variants.forEach(function (variant) {
          if (!variant.available) return;
          if (variant[optKey] !== val) return;

          availableAnywhere = true;

          const otherKeys = ['option1', 'option2', 'option3'].filter(function (key) {
            return key !== optKey && selected[key];
          });
          if (otherKeys.every(function (key) { return variant[key] === selected[key]; })) {
            availableWithSelection = true;
          }
        });

        const wrap = input.closest('.js-swatch-element');
        const isColorSwatch = !!(wrap && wrap.classList.contains('swatches__swatch--color'));
        const isSizeOption = !!input.closest('[data-mt-size-option]');

        // Color/Finish: clickable whenever this value has stock on any variant.
        // Size values remain selectable even when every matching variant is sold out.
        input.disabled = isSizeOption ? false : !availableAnywhere;
        if (wrap) {
          wrap.classList.toggle('soldout', !availableWithSelection);
          wrap.classList.toggle('soldout--unavailable', !availableAnywhere);
          if (isColorSwatch && availableAnywhere) {
            wrap.classList.remove('soldout--unavailable');
            input.disabled = false;
          }
        }
      });
    }

    function resolveVariant(changedInput) {
      const groups = getGroups();
      let options = getCheckedOptions();
      let variant = matchVariant(options);
      const changedSizeOption = !!(changedInput && changedInput.closest('[data-mt-size-option]'));

      // Preserve an exact selection even when it is sold out. This lets the UI
      // show the chosen size and switch the purchase area to its sold-out state.
      if (variant && (variant.available || changedSizeOption)) return variant;

      let candidates = product.variants.filter(function (v) { return v.available; });

      if (changedInput) {
        const groupIndex = groups.indexOf(changedInput.closest('.js-variant-selector'));
        if (groupIndex >= 0) {
          const changedValue = changedInput.value;
          candidates = candidates.filter(function (v) {
            return v.options[groupIndex] === changedValue;
          });
        }
      }

      function matchScore(v) {
        return options.reduce(function (score, opt, index) {
          return score + (opt != null && v.options[index] === opt ? 1 : 0);
        }, 0);
      }

      candidates.sort(function (a, b) {
        return matchScore(b) - matchScore(a);
      });

      variant = candidates[0] || variant;
      if (!variant) return null;

      applyVariantToUi(variant);
      return variant;
    }

    function updatePrice(variant) {
      const priceRoot = section.querySelector('[data-price]');
      if (!priceRoot || !variant) return;

      const onSale = variant.compare_at_price > variant.price;
      const formatted = formatMoney(variant.price, moneyFormat);
      const compareFormatted = formatMoney(variant.compare_at_price, moneyFormat);
      const config = getFormConfig(section);
      const soldOutLabel = section.dataset.soldOutLabel || config.sold_out || 'Sold Out';
      const savingsTemplate = config.savings || 'Save {{ savings }}';

      priceRoot.classList.toggle('price--on-sale', onSale && variant.available);
      if (onSale && !variant.available) {
        priceRoot.classList.add('price--sold-out', 'price--on-sale');
      } else if (!variant.available) {
        priceRoot.classList.add('price--sold-out');
        priceRoot.classList.remove('price--on-sale');
      } else {
        priceRoot.classList.remove('price--sold-out');
        if (!onSale) priceRoot.classList.remove('price--on-sale');
      }

      const regularEl = priceRoot.querySelector('.price__regular .price-item--regular');
      const saleEl = priceRoot.querySelector('.price__sale .price-item--sale');
      const compareEl = priceRoot.querySelector('.price__sale .price-item--regular');

      if (regularEl) regularEl.textContent = formatted;

      if (onSale) {
        if (saleEl) saleEl.textContent = formatted;
        if (compareEl) compareEl.textContent = compareFormatted;
      } else {
        if (saleEl) saleEl.textContent = '';
        if (compareEl) compareEl.textContent = '';
      }

      const saleBadge = priceRoot.querySelector('.price__badge--sale');
      if (saleBadge) {
        if (onSale && variant.compare_at_price > 0) {
          const difference = variant.compare_at_price - variant.price;
          const percent = Math.floor((difference / variant.compare_at_price) * 100) + '%';
          const savingsText = savingsTemplate.replace(/{{\s*savings\s*}}/i, percent);
          saleBadge.innerHTML = '<div class="sale-item--percentage">' + savingsText + '</div>';
        } else {
          saleBadge.innerHTML = '';
        }
      }

      const soldOutBadge = priceRoot.querySelector('.price__badge--sold-out');
      if (soldOutBadge) {
        soldOutBadge.innerHTML = variant.available ? '' : '<span>' + soldOutLabel + '</span>';
      }

      const saveWrap = section.querySelector('[data-mt-product-save]');
      const saveAmount = section.querySelector('[data-mt-save-amount]');
      if (saveWrap && saveAmount) {
        if (onSale) {
          saveAmount.textContent = formatMoney(variant.compare_at_price - variant.price, moneyFormat);
          saveWrap.hidden = false;
        } else {
          saveWrap.hidden = true;
        }
      }
    }

    function syncVariantId(variant) {
      if (!variant) return;
      section.querySelectorAll('.formVariantId').forEach(function (input) {
        input.value = variant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    function updateGallery(variant) {
      if (variant.featured_media && variant.featured_media.id && section.mtSetMainImageByMediaId) {
        section.mtSetMainImageByMediaId(variant.featured_media.id);
      } else if (variant.featured_image && variant.featured_image.src && section.mtSetMainImageByImageSrc) {
        section.mtSetMainImageByImageSrc(variant.featured_image.src);
      }
    }

    function handleVariantChange(changedInput) {
      const variant = resolveVariant(changedInput);
      if (!variant) {
        updateOptionLabels();
        updateSoldOutStates();
        updateAddToCartState(section, null);
        return;
      }

      updateOptionLabels();
      updateSoldOutStates();
      updatePrice(variant);
      syncVariantId(variant);
      if (changedInput) {
        updateGallery(variant);
      }
      updateAddToCartState(section, variant);
    }

    function optionValueHasStock(input) {
      if (!input) return false;
      const optKey = 'option' + input.dataset.position;
      const val = input.value;
      return product.variants.some(function (variant) {
        return variant.available && variant[optKey] === val;
      });
    }

    optionsWrap.addEventListener('change', function (event) {
      if (event.target.matches('input[type="radio"]')) {
        handleVariantChange(event.target);
      }
    });

    optionsWrap.addEventListener('click', function (event) {
      const label = event.target.closest('.swatches__form--label');
      if (!label) return;

      const input = document.getElementById(label.getAttribute('for'));
      if (!input) return;

      const wrap = input.closest('.js-swatch-element');
      const isColorSwatch = !!(wrap && wrap.classList.contains('swatches__swatch--color'));
      const isSizeOption = !!input.closest('[data-mt-size-option]');
      const hasStock = optionValueHasStock(input);

      // Size values are always selectable. The exact variant availability is
      // resolved after selection and reflected in the purchase-button state.
      if (isSizeOption) {
        event.preventDefault();
        input.disabled = false;
        if (!input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }

      // Color/Finish with any in-stock variant: always allow select + rematch.
      if (isColorSwatch && hasStock) {
        event.preventDefault();
        input.disabled = false;
        if (wrap) wrap.classList.remove('soldout--unavailable');
        if (!input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }

      // Fully unavailable option values cannot be selected.
      if (input.disabled || !hasStock) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      // Sold-out for the current combo but available elsewhere: force-select and
      // let resolveVariant pick a matching in-stock combination.
      if (wrap && wrap.classList.contains('soldout') && !input.checked) {
        event.preventDefault();
        input.disabled = false;
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    handleVariantChange(null);

    // Theme.js may toggle soldout classes after our update — re-assert clickability.
    if (typeof Events !== 'undefined' && Events.on) {
      Events.on('variantchange', function () {
        window.setTimeout(updateSoldOutStates, 0);
      });
    }

    if (typeof Events !== 'undefined') {
      Events.on('variantchange:image', function (mediaId, eventContext) {
        if (eventContext !== section) return;
        if (section.mtSetMainImageByMediaId) {
          section.mtSetMainImageByMediaId(mediaId);
        }
      });
    }
  }

  function getCartConfig() {
    const el = document.getElementById('cart-config');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      return null;
    }
  }

  function bindFeaturedAtc() {
    /* Main ATC uses document delegation in theme.js — no per-button handlers here. */
  }

  function applyFeaturedCollapse(wrap) {
    const visibleLimit = parseInt(wrap.dataset.visibleLimit, 10) || 1;
    const items = wrap.querySelectorAll('[data-mt-featured-item]');
    const toggle = wrap.querySelector('[data-mt-featured-toggle]');

    items.forEach(function (item, index) {
      item.classList.toggle('is-collapsed', index >= visibleLimit);
    });

    if (items.length > visibleLimit && toggle) {
      wrap.classList.add('mt-product-information__featured--collapsible');
      toggle.hidden = false;
      toggle.classList.remove('is-hidden');
    } else if (toggle) {
      toggle.hidden = true;
      toggle.classList.add('is-hidden');
    }
  }

  function bindFeaturedToggle(wrap) {
    const toggle = wrap.querySelector('[data-mt-featured-toggle]');
    if (!toggle || toggle.dataset.mtFeaturedToggleBound === 'true') return;

    toggle.dataset.mtFeaturedToggleBound = 'true';
    const moreLabel = toggle.dataset.viewMoreLabel || 'View More';
    const lessLabel = toggle.dataset.viewLessLabel || 'View Less';
    const labelEl = toggle.querySelector('[data-mt-featured-toggle-label]');

    toggle.addEventListener('click', function () {
      const expanded = wrap.classList.toggle('mt-product-information__featured--expanded');
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (labelEl) {
        labelEl.textContent = expanded ? lessLabel : moreLabel;
      }
    });
  }

  function loadFeaturedRecommendations(wrap) {
    if (wrap.dataset.mtFeaturedLoaded === 'true') return;
    if (wrap.dataset.mtFeaturedSource !== 'recommendations') return;

    const list = wrap.querySelector('[data-mt-featured-list]');
    const loading = wrap.querySelector('[data-mt-featured-loading]');
    const baseUrl = wrap.dataset.baseUrl;
    const productId = wrap.dataset.productId;
    const sectionId = wrap.dataset.sectionId;
    if (!list || !baseUrl || !productId || !sectionId) return;

    const limit = wrap.dataset.recommendationLimit || '6';
    const url =
      baseUrl +
      '?section_id=' +
      encodeURIComponent(sectionId) +
      '&product_id=' +
      encodeURIComponent(productId) +
      '&limit=' +
      encodeURIComponent(limit);

    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        if (loading) loading.remove();

        if (!html || !html.trim()) {
          wrap.hidden = true;
          wrap.dataset.mtFeaturedLoaded = 'true';
          return;
        }

        const temp = document.createElement('div');
        temp.innerHTML = html;
        const sectionEl = temp.querySelector('.shopify-section');
        const content = sectionEl ? sectionEl.innerHTML : html;

        if (!content.trim()) {
          wrap.hidden = true;
          wrap.dataset.mtFeaturedLoaded = 'true';
          return;
        }

        list.insertAdjacentHTML('beforeend', content);
        wrap.dataset.mtFeaturedLoaded = 'true';

        const items = list.querySelectorAll('[data-mt-featured-item]');
        if (items.length === 0) {
          wrap.hidden = true;
          return;
        }

        applyFeaturedCollapse(wrap);
        bindFeaturedAtc(wrap);
      })
      .catch(function () {
        if (loading) loading.remove();
        wrap.hidden = true;
        wrap.dataset.mtFeaturedLoaded = 'true';
      });
  }

  function bindFeaturedProducts(section) {
    section.querySelectorAll('[data-mt-featured-products]').forEach(function (wrap) {
      bindFeaturedToggle(wrap);

      if (wrap.dataset.mtFeaturedSource === 'custom') {
        bindFeaturedAtc(wrap);
        applyFeaturedCollapse(wrap);
        return;
      }

      loadFeaturedRecommendations(wrap);
    });
  }

  function isEmptyAccordionInner(inner) {
    if (!inner) return true;
    if (inner.querySelector('img, video, iframe, audio, picture, svg, table')) return false;
    return (inner.textContent || '').replace(/\s+/g, '').length === 0;
  }

  function removeEmptyAccordionItems(accordion) {
    accordion.querySelectorAll('.mt-product-information__accordion-panel').forEach(function (panel) {
      const inner = panel.querySelector('.c-accordion__inner');
      if (!isEmptyAccordionInner(inner)) return;

      const header = accordion.querySelector('[aria-controls="' + panel.id + '"]');
      if (header) header.remove();
      panel.remove();
    });

    if (!accordion.querySelector('.mt-product-information__accordion-panel')) {
      const wrap = accordion.closest('.mt-product-information__accordion-wrap');
      if (wrap) wrap.remove();
    }
  }

  function bindAccordion(section) {
    const accordion = section.querySelector('.mt-product-information__accordion');
    if (!accordion || accordion.dataset.mtAccordionBound === 'true') return;

    removeEmptyAccordionItems(accordion);
    if (!section.querySelector('.mt-product-information__accordion')) return;

    accordion.dataset.mtAccordionBound = 'true';

    function releasePanelHeight(panel) {
      if (!panel || !panel.classList.contains('is-active')) return;
      panel.style.maxHeight = 'none';
      panel.style.overflow = 'visible';
    }

    function refreshOpenPanels() {
      accordion.querySelectorAll('.mt-product-information__accordion-panel.is-active').forEach(releasePanelHeight);
    }

    // Theme already calls WAU.Accordion.init() once on DOMContentLoaded.
    // Calling init() again adds duplicate document click listeners, so one
    // click toggles twice (open then immediately close).
    accordion.querySelectorAll('.js-accordion-header:not(.js-accordion-is-open)').forEach(function (header) {
      if (typeof WAU !== 'undefined' && WAU.Accordion && WAU.Accordion.hide) {
        WAU.Accordion.hide(header);
        return;
      }

      const panelId = header.getAttribute('aria-controls');
      const panel = panelId ? document.getElementById(panelId) : null;
      if (panel && !panel.classList.contains('is-active')) {
        panel.setAttribute('hidden', '');
        panel.style.display = 'none';
      }
    });

    refreshOpenPanels();

    accordion.querySelectorAll('.mt-product-information__accordion-panel').forEach(function (panel) {
      if (typeof MutationObserver !== 'undefined') {
        const observer = new MutationObserver(function () {
          if (panel.classList.contains('is-active')) {
            releasePanelHeight(panel);
          } else {
            panel.style.removeProperty('max-height');
            panel.style.removeProperty('overflow');
          }
        });
        observer.observe(panel, { attributes: true, attributeFilter: ['class'] });
      }

      panel.querySelectorAll('img').forEach(function (img) {
        if (!img.complete) {
          img.addEventListener('load', function () {
            releasePanelHeight(panel);
          });
        }
      });
    });
  }

  function bindRatingVisibility(section) {
    const rating = section.querySelector('[data-mt-product-rating]');
    if (!rating || rating.dataset.mtRatingBound === 'true') return;

    rating.dataset.mtRatingBound = 'true';

    function isJudgeMeBadgeHidden(badge) {
      if (!badge) return true;
      if (badge.style.display === 'none') return true;
      const style = window.getComputedStyle(badge);
      return style.display === 'none' || style.visibility === 'hidden';
    }

    function hasReviews() {
      if (rating.querySelector('.mt-product-rating--shopify')) {
        return true;
      }

      const badge = rating.querySelector('.jdgm-preview-badge');
      if (!badge) {
        return false;
      }

      if (isJudgeMeBadgeHidden(badge)) {
        return false;
      }

      const reviewCount = parseInt(badge.getAttribute('data-number-of-reviews') || '0', 10);
      if (reviewCount > 0) {
        return true;
      }

      const averageRating = parseFloat(badge.getAttribute('data-average-rating') || '0');
      if (!isNaN(averageRating) && averageRating > 0) {
        return true;
      }

      if (badge.querySelector('.jdgm-star')) {
        return true;
      }

      return false;
    }

    function update() {
      rating.classList.toggle('has-reviews', hasReviews());
    }

    update();

    if (rating.querySelector('.jdgm-preview-badge')) {
      const observer = new MutationObserver(update);
      observer.observe(rating, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class', 'data-number-of-reviews', 'data-average-rating'],
      });

      [100, 300, 800, 1500, 3000, 5000, 8000].forEach(function (delay) {
        window.setTimeout(update, delay);
      });
    }
  }

  function bindSwatchListCollapse(section) {
    const optionsWrap = section.querySelector('.mt-product-information__options');
    if (!optionsWrap || optionsWrap.dataset.mtSwatchCollapseBound === 'true') return;
    optionsWrap.dataset.mtSwatchCollapseBound = 'true';

    const mobileMq = window.matchMedia('(max-width: 749px)');
    const ROW_LIMIT = 2;

    function measureCollapsedHeight(list) {
      const items = Array.from(list.children).filter(function (el) {
        return el.nodeType === 1 && el.getClientRects().length > 0;
      });
      if (!items.length) return 0;

      // Use list-relative tops. offsetTop is relative to offsetParent and can be
      // much larger than the list, which made max-height too big to ever clip.
      const listTop = list.getBoundingClientRect().top;
      const rows = [];

      items.forEach(function (item) {
        const rect = item.getBoundingClientRect();
        const top = Math.round(rect.top - listTop);
        const bottom = rect.bottom - listTop;
        let row = null;
        for (let i = 0; i < rows.length; i++) {
          if (Math.abs(rows[i].top - top) <= 2) {
            row = rows[i];
            break;
          }
        }
        if (!row) {
          row = { top: top, bottom: bottom };
          rows.push(row);
        } else {
          row.bottom = Math.max(row.bottom, bottom);
        }
      });

      rows.sort(function (a, b) { return a.top - b.top; });
      if (rows.length <= ROW_LIMIT) return 0;

      return Math.ceil(rows[ROW_LIMIT - 1].bottom);
    }

    function syncContainer(container) {
      const list = container.querySelector('[data-mt-swatch-list]') || container.querySelector('.swatches__list');
      const toggle = container.querySelector('[data-mt-swatch-toggle]');
      if (!list || !toggle) return;

      const label = toggle.querySelector('[data-mt-swatch-toggle-label]');
      const optionName = toggle.dataset.mtOptionName || 'Size';
      function updateToggleState(expanded) {
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        toggle.setAttribute(
          'aria-label',
          expanded ? 'Show fewer ' + optionName + ' options' : 'Show all ' + optionName + ' options'
        );
        if (label) label.textContent = expanded ? 'Show Less' : 'All Sizes';
      }

      if (!mobileMq.matches) {
        container.classList.remove('is-collapsible', 'is-expanded');
        list.style.removeProperty('--mt-swatch-list-collapsed-height');
        list.style.removeProperty('max-height');
        toggle.hidden = true;
        updateToggleState(false);
        return;
      }

      const wasExpanded = container.classList.contains('is-expanded');
      // Temporarily unlock height so we can measure real row count.
      container.classList.remove('is-collapsible', 'is-expanded');
      list.style.removeProperty('max-height');
      list.style.removeProperty('--mt-swatch-list-collapsed-height');

      const collapsedHeight = measureCollapsedHeight(list);
      const needsCollapse = collapsedHeight > 0;

      container.classList.toggle('is-collapsible', needsCollapse);
      toggle.hidden = !needsCollapse;

      if (!needsCollapse) {
        list.style.removeProperty('max-height');
        updateToggleState(false);
        return;
      }

      list.style.setProperty('--mt-swatch-list-collapsed-height', collapsedHeight + 'px');

      if (wasExpanded) {
        container.classList.add('is-expanded');
        updateToggleState(true);
      } else {
        // Set inline max-height too so clipping doesn't depend only on CSS var timing.
        list.style.maxHeight = collapsedHeight + 'px';
        updateToggleState(false);
      }
    }

    function syncAll() {
      optionsWrap.querySelectorAll('[data-mt-size-option]').forEach(syncContainer);
    }

    optionsWrap.addEventListener('click', function (event) {
      const toggle = event.target.closest('[data-mt-swatch-toggle]');
      if (!toggle || !optionsWrap.contains(toggle)) return;

      const container = toggle.closest('.swatches__container');
      if (!container || !container.classList.contains('is-collapsible')) return;

      const list = container.querySelector('[data-mt-swatch-list]') || container.querySelector('.swatches__list');
      const expanded = container.classList.toggle('is-expanded');
      const label = toggle.querySelector('[data-mt-swatch-toggle-label]');
      const optionName = toggle.dataset.mtOptionName || 'Size';
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      toggle.setAttribute(
        'aria-label',
        expanded ? 'Show fewer ' + optionName + ' options' : 'Show all ' + optionName + ' options'
      );
      if (label) label.textContent = expanded ? 'Show Less' : 'All Sizes';

      if (!list) return;
      if (expanded) {
        list.style.removeProperty('max-height');
      } else {
        const collapsedHeight = list.style.getPropertyValue('--mt-swatch-list-collapsed-height');
        if (collapsedHeight) list.style.maxHeight = collapsedHeight;
      }
    });

    syncAll();

    let resizeTimer = null;
    function onViewportChange() {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(syncAll, 100);
    }

    if (mobileMq.addEventListener) {
      mobileMq.addEventListener('change', onViewportChange);
    } else if (mobileMq.addListener) {
      mobileMq.addListener(onViewportChange);
    }
    window.addEventListener('resize', onViewportChange);

    // Re-measure after fonts/layout settle and after variant UI updates.
    window.setTimeout(syncAll, 50);
    window.setTimeout(syncAll, 300);
  }

  function initSection(section) {
    if (!section || !section.matches('[data-mt-product-information]')) return;

    section.mtUpdateAddToCartState = function () {
      const product = getProductData(section);
      const variant = getSelectedVariant(section);
      if (product && variant) {
        const stored = product.variants.find(function (v) {
          return v.id === variant.id;
        });
        if (stored) stored.available = false;
      }
      updateAddToCartState(section, variant ? Object.assign({}, variant, { available: false }) : null);
    };

    section.mtSyncVariantBeforeCart = function () {
      return syncVariantIdFromSelection(section);
    };

    bindGallery(section);
    bindDiscountCopy(section);
    bindQuantityControls(section);
    bindMainAddToCart(section);
    bindPriceFromCleanup(section);
    bindVariantExtras(section);
    bindSwatchListCollapse(section);
    bindFeaturedProducts(section);
    bindAccordion(section);
    bindRatingVisibility(section);

    syncVariantIdFromSelection(section);
    initAddToCartAvailability(section);
  }

  function initAll() {
    document.querySelectorAll('[data-mt-product-information]').forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.matches('[data-mt-product-information]')) {
      delete event.target.dataset.mtVariantPickerBound;
      delete event.target.dataset.mtPriceFromBound;
      const optionsWrap = event.target.querySelector('.mt-product-information__options');
      if (optionsWrap) delete optionsWrap.dataset.mtSwatchCollapseBound;
      initSection(event.target);
    }
  });
})();
